module.exports = __webpack_public_path__ + "img/FIRE_DRAGON_A1010.f2f03001.png";